export const LOAD_ORDERS = 'LOAD_ORDERS';

/* Shipment */
export const loadOrders = (data) => {
  return {
    type: LOAD_ORDERS,
    value: data
  }
}
